export type AvatarApiErrorBody = {
  error?: string
  code?: string
  message?: string
}

export type AvatarMutationResponseMeta = {
  hasDailyWarning: boolean
}

type AvatarApiResponseLike = {
  headers: Pick<Headers, 'get'>
  json: () => Promise<unknown>
}

export const readAvatarApiErrorBody = async (response: AvatarApiResponseLike): Promise<AvatarApiErrorBody | null> => {
  return (await response.json().catch(() => null)) as AvatarApiErrorBody | null
}

export const readRequiredHeader = (response: AvatarApiResponseLike, headerName: string): string => {
  const value = response.headers.get(headerName)
  if (!value) {
    throw new Error(`${headerName} header is missing`)
  }

  return value
}

export const hasAvatarDailyWarning = (response: AvatarApiResponseLike): boolean =>
  response.headers.get('X-Avatar-Daily-Warning') === 'true'

export const getRetryAfterSeconds = (response: AvatarApiResponseLike): number | null => {
  const value = response.headers.get('Retry-After')
  if (!value) return null

  const parsed = Number.parseInt(value, 10)
  return Number.isFinite(parsed) ? parsed : null
}
